import React from "react";

/**
 * ANY Web brand mark — red asterisk icon only.
 * Use for favicons, compact header marks, and anywhere space is tight.
 */
export const AnyMark = ({ size = 24 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" width={size} height={size} style={{ display: "block" }}>
    <rect width="72" height="72" rx="16" fill="#A32D2D" />
    <line x1="36" y1="18" x2="36" y2="54" stroke="#FCEBEB" strokeWidth="4" strokeLinecap="round" />
    <line x1="20.4" y1="27" x2="51.6" y2="45" stroke="#FCEBEB" strokeWidth="4" strokeLinecap="round" />
    <line x1="20.4" y1="45" x2="51.6" y2="27" stroke="#FCEBEB" strokeWidth="4" strokeLinecap="round" />
  </svg>
);

/**
 * Full ANY Web lockup — red mark + "ANY" (bold) + "Web" (regular).
 * Matches the brand system: Inter font, weights 700 + 400, letter-spacing -1.5.
 *
 * @param {number} height  Pixel height of the lockup (icon scales with it)
 * @param {boolean} dark   Set true for dark backgrounds (switches wordmark ink to cream)
 */
export const AnyLogo = ({ height = 24, dark = false }) => {
  const ink = dark ? "#FAFAF7" : "#2C2C2A";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 310 72"
      height={height}
      style={{ width: "auto", display: "block" }}
      aria-label="ANY Web"
    >
      <rect width="72" height="72" rx="16" fill="#A32D2D" />
      <line x1="36" y1="18" x2="36" y2="54" stroke="#FCEBEB" strokeWidth="4" strokeLinecap="round" />
      <line x1="20.4" y1="27" x2="51.6" y2="45" stroke="#FCEBEB" strokeWidth="4" strokeLinecap="round" />
      <line x1="20.4" y1="45" x2="51.6" y2="27" stroke="#FCEBEB" strokeWidth="4" strokeLinecap="round" />
      <text x="92" y="52" fontFamily="Inter, -apple-system, 'Helvetica Neue', sans-serif" fontSize="46" fontWeight="700" fill={ink} letterSpacing="-1.5">ANY</text>
      <text x="198" y="52" fontFamily="Inter, -apple-system, 'Helvetica Neue', sans-serif" fontSize="46" fontWeight="400" fill={ink} letterSpacing="-1.5">Web</text>
    </svg>
  );
};

export default AnyLogo;
